import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackBarComponent } from '../common/components/snack-bar/snack-bar.component';
import { AuthService } from '../../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LoaderComponent } from '../common/components/loader/loader.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { ErrorNotficationComponent } from '../../error-notfication/error-notfication.component';
import { MatDialog } from '@angular/material/dialog';
import { SsoService } from '../../services/auth_sso/auth_sso.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatButtonModule, MatFormFieldModule, MatInputModule, LoaderComponent, MatCheckboxModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  public loginForm: FormGroup;
  public isLoading: boolean = false;

  constructor(private fb: FormBuilder,private dialog: MatDialog, private authService: AuthService,private SsoService: SsoService, private router: Router, private snackBar: MatSnackBar, private sanitizer: DomSanitizer) {
    this.loginForm = this.fb.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: ['', Validators.required],
      disclaimer: [false, Validators.requiredTrue],
      terms: [false, Validators.requiredTrue]
    });
  }
  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.authService.logout();
    }
  }

  login() {
    this.SsoService.login();
  }

  onSubmit() {
    this.isLoading = true;
    if (this.loginForm.valid) {
      const formValue = this.loginForm.value;
      const formData = new FormData();
      formData.append('username', formValue.email.trim());
      formData.append('password', formValue.password.trim());
      this.authService.login(formData).subscribe((res : any) => {
        localStorage.setItem('accessToken', res?.access_token);
        localStorage.setItem("refresh_token", res?.refresh_token);
        localStorage.setItem('user', res?.user?.role_name);
        localStorage.setItem('user_id', res?.user?.user_id)
        localStorage.setItem('user_name', res?.user?.username)
        if (res.user.role_name === 'admin') {
          this.router.navigate(['home/user-configuration']);
        } else {
          this.router.navigate(['/home']);
        }
      }, (error : any) => {
        if (error?.status === 401) {
          this.openSnackbar(error?.error?.detail, 'An error occurred', 'error-snackbar');
        } else if (error?.status === 403) {
          const extractedEmail = this.extractEmail(error?.error?.detail);
          const parts = error?.error?.detail.split(extractedEmail);
          const beforeEmail = parts[0];
          const afterEmail = parts[1] || '';
          const formattedMessage = `${beforeEmail}<strong>${extractedEmail}</strong>${afterEmail}`;
          const sanitizedMessage: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(formattedMessage);
          this.openSnackbar(sanitizedMessage, 'An error occurred', 'show-full-message');
        } else {
          this.openSnackbar('Something went wrong!, please try after some time...', 'An error occurred', 'error-snackbar');
        }
        this.isLoading = false;
      })
    } else {
      this.isLoading = false;
    }
  }

  extractEmail(input: string): string {
    const emailPattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}\b/;
    const match = input.match(emailPattern);
    return match ? match[0] : '';
  }

  openSnackbar(message: any, title: string, cssClass: string) {
    // this.snackBar.openFromComponent(SnackBarComponent, {
    //   data: { message: message, type: type },
    //   duration: 3000, // Duration in milliseconds,
    //   horizontalPosition: 'center',
    //   verticalPosition: 'top',
    //   panelClass: [cssClass],
    // });
     const dialogRef = this.dialog.open(ErrorNotficationComponent, {
                   data: {
                     message: message,
                     title: title,
                     action_type: 'add',
                     cssClass: cssClass
                   }
                 });
  }
}
